import {resetButton, loadingButton} from "./dom";

export function setToLoading(): void {
    resetButton.classList.add("hidden");
    loadingButton.classList.remove("hidden");
}

export function disableLoading(): void {
    loadingButton.classList.add("hidden");
    resetButton.classList.remove("hidden");
}